
export { default as cond } from "./cond.js"